import React, { lazy, Suspense } from 'react';

import PageLoader from './PageLoader';
import attemptLoading from 'utils/combativeLoader';

const DynamicLoader = (path: () => Promise<any>, CustomLoader?: React.Component): React.FC => {
  const AsyncComponent: React.FC = lazy(() => attemptLoading(path));

  return props => {
    return (
      <Suspense fallback={CustomLoader ? CustomLoader : <PageLoader />}>
        <AsyncComponent {...props} />
      </Suspense>
    );
  };
};

export default DynamicLoader;
